
import { Cmd_none, Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ImportResult_$reflection, ImportDataResponse_$reflection, ImportValidateResponse_$reflection } from "../../Shared/Importer.js";
import { PostResponse$1_$reflection } from "../../Shared/Shared.js";
import { State, Msg } from "./Types.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";

export function validateCmd(formData) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(tupledArg[0]), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), undefined, (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(ImportValidateResponse_$reflection())));
    })))), ["/api/import/validate/labels", formData], (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(4, [Item_1])));
}

export function importCmd(importData) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(tupledArg[0]), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(ImportDataResponse_$reflection())));
    })))), ["/api/import/labels", toString(0, Auto_generateBoxedEncoder_437914C6(ImportResult_$reflection(), undefined, undefined, undefined)(importData))], (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(4, [Item_1])));
}

export function init() {
    return [new State(undefined, false, undefined), Cmd_none()];
}

export function update(msg, state) {
    let matchValue;
    switch (msg.tag) {
        case 1: {
            const matchValue_1 = msg.fields[0].Result;
            switch (matchValue_1.tag) {
                case 2:
                    return [new State(undefined, false, "importer.user_limit_reached_msg"), Cmd_errorToast("importer.failed_imported_data")];
                case 3:
                    return [new State(undefined, false, "importer.tool_limit_reached_msg"), Cmd_errorToast("importer.failed_imported_data")];
                case 1:
                    return [new State(undefined, false, "importer.data_not_valid"), Cmd_errorToast("importer.failed_imported_data")];
                case 4:
                    return [new State(undefined, false, state.ValidateErrorMessage), Cmd_errorToast("importer.failed_imported_data")];
                default:
                    return [new State(matchValue_1.fields[0], false, state.ValidateErrorMessage), Cmd_successToast("importer.successfully_imported_data")];
            }
        }
        case 2:
            return [new State(undefined, true, undefined), validateCmd(msg.fields[0])];
        case 3: {
            const matchValue_2 = msg.fields[0].Result;
            switch (matchValue_2.tag) {
                case 1:
                    return [new State(undefined, false, "importer.user_limit_reached_msg"), Cmd_errorToast("importer.failed_validate_data")];
                case 2:
                    return [new State(undefined, false, "importer.tool_limit_reached_msg"), Cmd_errorToast("importer.failed_validate_data")];
                case 3:
                    return [new State(state.Import, false, "importer.validation_error"), Cmd_none()];
                default:
                    return [new State(matchValue_2.fields[0], false, state.ValidateErrorMessage), Cmd_none()];
            }
        }
        case 4:
            return [new State(state.Import, false, "importer.csv_validation_failure"), Cmd_none()];
        default:
            return [new State(state.Import, true, state.ValidateErrorMessage), (matchValue = state.Import, (matchValue == null) ? Cmd_none() : importCmd(matchValue))];
    }
}

